import { FC, useEffect } from 'react';
import { useQueryClient } from 'react-query';

import {
  GetQuotationsByFileIdQuery,
  useGetQuotationsByFileIdQuery,
} from '@savgroup-front-common/core/components/Quotation/hooks/useGetQuotationsByFileIdQuery';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { QuotationState } from '@savgroup-front-common/types';

import { CustomerFile } from '../../../../../../../types';

import AnswerQuotationContent from './AnswerQuotationContent';

interface AnswerQuotationProps {
  file: CustomerFile;
  isLoading: boolean;
}

const AnswerQuotation: FC<AnswerQuotationProps> = ({ file, isLoading }) => {
  const { quotations } = useGetQuotationsByFileIdQuery({
    fileId: file.fileId,
    refetchOnMount: false,
  });

  const currentQuotation = (quotations || []).find(
    (quotation) =>
      quotation.state === QuotationState.PENDING_CUSTOMER_VALIDATION,
  );

  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries([GetQuotationsByFileIdQuery]);
  }, [queryClient]);

  if (!currentQuotation || isLoading) {
    return <BaseLoader />;
  }

  return (
    <AnswerQuotationContent
      quotation={currentQuotation}
      sellerId={file.sellerId}
      fileId={file.fileId}
      isOpen
    />
  );
};

AnswerQuotation.displayName = 'AnswerQuotation';

export default AnswerQuotation;
